import React, { useMemo } from 'react';
import { useCard } from '../../themes/cardStyles';
import { buildPaletteTheme } from '../../themes/palettes';
import { countdownLabel } from '../../derivations/schedule';

export const NextSessionCard = ({ theme, density, schedule, palette, cardStyle, cardFinish }) => {
  const c = theme.colors;
  const t = theme.typography || {};
  const e = theme.effects || {};

  const countdown = countdownLabel(schedule);
  const isTonight = countdown === 'Tonight';

  const tintedTheme = useMemo(
    () => buildPaletteTheme(theme, palette, cardStyle, cardFinish),
    [theme, palette, cardStyle, cardFinish]
  );
  const cardObj = useCard(tintedTheme, cardStyle, false);

  return (
    <div style={{
      ...cardObj,
      padding: '14px 16px 14px 27px',
      display: 'flex', alignItems: 'center', gap: 14,
    }}>
      <div style={{ flex: 1 }}>
        <div style={{
          fontFamily: t.headingFamily,
          fontSize: '1.4rem', fontWeight: 600,
          color: schedule ? palette.light : c.textMuted,
          lineHeight: 1.1,
          textShadow: isTonight ? `0 0 18px ${palette.glow}` : e.headingTextShadow,
          fontStyle: schedule ? 'normal' : 'italic',
        }}>{schedule ? (countdown || schedule) : 'No session scheduled'}</div>
        {schedule && (
          <div style={{
            fontSize: '0.78rem', color: c.textMuted, marginTop: 3,
            fontFamily: t.fontFamily,
          }}>{schedule}</div>
        )}
      </div>
    </div>
  );
};
